export const factListConstants = {
    GET_FACT_LIST_PENDING  : 'GET_FACT_LIST_PENDING',
    GET_FACT_LIST_FULFILLED: 'GET_FACT_LIST_FULFILLED',
    GET_FACT_LIST_REJECTED : 'GET_FACT_LIST_REJECTED',
}
